import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { CalendarList, CalendarRegulationList, CalendarRiskList, CalendarSurveyRiskList } from '../components';
import { CalendarAction } from '../features/calendar.feature';
import { useAppDispatch, useAppSelector } from '../hooks';

const CalendarRoute = () => {
    const dispatch = useAppDispatch();

    const selectedVessels = useAppSelector((state) => state.Calendar.Filters.Vessels);
    const surveyFilter = useAppSelector((state) => state.Calendar.Filters.Surveys);

    useEffect(() => {
        return () => {
            dispatch(CalendarAction.CancelApiRequests());
        };
    }, [dispatch]);

    return (
        <Stack direction={'row'} gap={2}>
            <Stack direction={'column'} width={'50%'} style={{ alignItems: 'center' }}>
                <CalendarList />
            </Stack>
            <Stack direction={'column'} justifyContent={'flex-start'} style={{ width: '50%' }}>
                {surveyFilter !== undefined && surveyFilter.length < 1 && (!selectedVessels || (selectedVessels && selectedVessels.length > 0) ? <CalendarRiskList /> : <CalendarRegulationList />)}
                {surveyFilter !== undefined && surveyFilter.length > 0 && <CalendarSurveyRiskList />}
            </Stack>
        </Stack>
    );
};

export default CalendarRoute;
